<template>
  <div class="conversation-item" :class="{'my':item.send}">
    <van-image :src="item?.user_extra?.avatar" round class="user-avatar" />
    <div class="info">
      <div class="title">
        <h3 class="name">{{item?.user_extra?.nickname||'匿名'}}</h3>
        <!-- <img :src="getLvUrl(item?.user_extra?.level)" class="img-lv" /> -->
        <!-- <p class="time">
          {{moment(item.timestamp * 1000).format('HH:mm')}}
        </p> -->
        <div class=""></div>
        <div v-if="state.czshow" class="cz-box" ref="popupRef">
          <div class="cz-box-item" @click="sendDataToAncestor(item)">
            回复
          </div>
          <div v-if="isChShow(item)" class="cz-box-item" @click="onCh(item)">
            撤回
          </div>
        </div>
      </div>
      <div class="pl-box">
        <div v-if="item.content?.reply" class="hf-box" @click="goTz(item.content?.reply.messageSeq)">
          <div class="hf-user">
            <img :src="findElementById(state.subscribers,item.content.reply.fromUID)?.avatar" />
            <p>{{findElementById(state.subscribers,item.content.reply.fromUID)?.nickname||'匿名'}}</p>
          </div>
          <div class="hf-pl">
            {{item.content.reply.content?.conversationDigest}}
          </div>
        </div>
        <div class="pl-content" @touchstart="handleTouchStart" @touchend="handleTouchEnd" @touchcancel="handleTouchEnd"
          @mousedown="handleMouseDown" @mouseup="handleMouseUp" @mouseleave="handleMouseUp">
          <span v-for="(sonitem,i) in parseMention(item.content)" :key="i+'parseMention'">
            <span v-if="sonitem.type===PartType.mention" class="pl-mention">
              {{sonitem.text}}
            </span>
            <span v-if="sonitem.type === PartType.text" class="pl-text" v-html="sonitem.text">
            </span>
          </span>
        </div>
      </div>

    </div>
    <div class="status" v-if="item.status == MessageStatus.Wait && item.send">发送中</div>
    <div class="status" v-if="item.status == MessageStatus.Fail && item.send">发送失败</div>
    <div class="status" v-if="item.status == 3 && item.send">不是好友或不在群内</div>
    <div class="status" v-if="item.status == 4 && item.send">黑名单</div>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
    ref,
    onUnmounted,
    inject,
    watch
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'
  import {
    Toast
  } from 'vant'
  import {
    useStore
  } from "vuex"
  import moment from 'moment';
  import {
    Channel,
    ChannelTypePerson,
    ChannelTypeGroup,
    WKSDK,
    MessageStatus
  } from "wukongimjssdk";
  import {
    messageRevoke
  } from "@/api/im.js";
  import {
    GroupRole
  } from "@/services/const.js";
  import {
    parseMention,
    PartType,
  } from "@/services/model.js";


  export default {
    name: 'conversationitemtext',
    props: ['item','subscribers'],
    setup(props, {
      emit
    }) {
      const store = useStore()

      const router = useRouter()
      const popupRef = ref(null)
      const state = reactive({
        uid: store.state.imuid,
        item: props.item,
        // 操作
        czshow: false,
        // 订阅者
        subscribers:null,
      })
      // 监听subscribers变化
      watch(
        () => props.subscribers,
        (newVal) => {
          state.subscribers = newVal
        }, {
          deep: true,
          immediate: true
        } // 配置项
      );
      const findElementById = (arr, fromUID) => {
        // find方法遍历数组，返回第一个满足条件的元素
        return arr.find(item => {
          if(item){
            return item.uid === fromUID
          }else{
            return null
          }
          
        });
      }
      // 获取等级
      const getLvUrl = (lv) => {
        // if (lv) {
        //   return require(`@/assets/lv/${lv}.png`)
        // } else {
        //   return require(`@/assets/lv/0.png`)
        // }

      }
      // 获取头像
      const getAvatar = (fromUID) => {
        return `${process.env.VUE_APP_BASE_IM_API}/api/v1/users/${fromUID}/avatar?v=`
      }
      // 获取昵称
      const getName = (fromUID) => {
        const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(fromUID, ChannelTypePerson))
        return channelInfo?.orgData.displayName
        // if (!channelInfo && fromUID && fromUID !== "") {
        //   WKSDK.shared().channelManager.fetchChannelInfo(new Channel(fromUID, ChannelTypePerson)).then(()=>{
        //     // 获取单人频道信息
        //     const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(fromUID, ChannelTypePerson))
        //     return channelInfo?.orgData.displayName
        //   })
        // }
      }
      // 判断是否能撤回
      const isChShow = (message) => {
        if (message.messageID == "") {
          return false;
        }

        let isManager = false;
        if (message.channel.channelType == ChannelTypeGroup) {
          const sub = WKSDK.shared().channelManager.getSubscribeOfMe(
            message.channel
          );
          if (sub?.role == GroupRole.manager || sub?.role == GroupRole.owner) {
            isManager = true;
          }
        }

        if (!isManager) {
          if (!message.send) {
            return false;
          }
          let revokeSecond = 2 * 60;
          if (revokeSecond > 0) {
            const messageTime = new Date().getTime() / 1000 - message.timestamp;
            if (messageTime > revokeSecond) {
              //  超过两分钟则不显示撤回
              return false;
            }
          }
        }

        return true
      }

      // 定时器标识
      let pressTimer = null

      // 长按阈值（毫秒），可根据需求调整
      const LONG_PRESS_TIME = 500

      // 触摸开始/鼠标按下事件
      const startPress = () => {
        // 启动定时器，达到阈值后显示弹窗
        pressTimer = setTimeout(() => {
          state.czshow = true
          // 弹窗显示后添加全局点击监听
          document.addEventListener('click', handleClickOutside)
        }, LONG_PRESS_TIME)
      }

      // 触摸结束/鼠标松开事件
      const endPress = () => {
        // 清除定时器，取消长按判定
        if (pressTimer) {
          clearTimeout(pressTimer)
          pressTimer = null
        }
      }

      // 触摸事件处理
      const handleTouchStart = (e) => {
        e.preventDefault() // 阻止默认行为（如滚动）
        startPress()
      }
      const handleTouchEnd = () => endPress()

      // 鼠标事件处理（兼容PC端）
      const handleMouseDown = (e) => {
        e.preventDefault()
        startPress()
      }
      const handleMouseUp = () => endPress()
      // 监听点击外部区域
      const handleClickOutside = (e) => {
        if (popupRef.value && !popupRef.value.contains(e.target)) {
          closePopup()
        }
      }
      // 关闭弹窗
      const closePopup = () => {
        state.czshow = false
        // 移除全局点击监听
        document.removeEventListener('click', handleClickOutside)
      }
      // 撤回消息
      const onCh = (item) => {
        messageRevoke({
          channel_id: item.channel.channelID,
          channel_type: item.channel.channelType,
          message_id: item.messageID,
          client_msg_no: item.clientMsgNo,
        }).then(() => {
          Toast('撤回成功')
        }).catch((err) => {
          Toast(err.msg);
        })
        closePopup()
      }
      const goTz = (messageSeq) => {
        emit('locateMessage',messageSeq)
      }
      onMounted(() => {
        // const parts = parseMention(props.item.content)
        // if (parts && parts.length > 0) {
        //   let i = 0
        //   for (const part of parts) {
        //     part.text.split("\n")
        //     if (part.type === PartType.text) {
        //       elements.push(this.getCommonText(i, part))
        //     } else if (part.type === PartType.mention) {
        //       elements.push(this.getMentionText(i, part))
        //     } else if (part.type === PartType.emoji) {
        //       elements.push(this.getEmojiText(i, part))
        //     } else if (part.type === PartType.link) {
        //       elements.push(this.getLinkText(i, part))
        //     }
        //     i++
        //   }
        // }
        // console.log(parseMention(props.item.content))
      })
      onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside)
      })
      // 返回
      const onClickLeft = () => {
        router.back()
      }
      // 注入祖宗组件提供的方法（key 要和 provide 的一致）
      const triggerAncestorMethod = inject('triggerAncestorMethod')
      // 点击回复触发，向祖宗组件传值
      const sendDataToAncestor = (item) => {
        // 传任意值（字符串、对象、数组等）
        triggerAncestorMethod(item)
        closePopup()
      }
      return {
        PartType,
        parseMention,
        popupRef,
        MessageStatus,
        moment,
        state,
        onClickLeft,
        getAvatar,
        getName,
        handleTouchEnd,
        handleMouseUp,
        handleMouseDown,
        handleTouchStart,
        getLvUrl,
        onCh,
        isChShow,
        sendDataToAncestor,
        goTz,
        findElementById,
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
  }

  .conversation-item .user-avatar {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .conversation-item .info {
    padding-left: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .conversation-item .info .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
  }

  .conversation-item .info .title .img-lv {
    width: 70px;
    margin-left: 10px;
  }

  .conversation-item .info .name {
    font-size: 28px;
    color: #fff;

  }

  .conversation-item .info .pl-box {
    background-color: #283138;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
  }

  .conversation-item .info .pl-box .hf-user {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .conversation-item .info .pl-box .hf-user img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .conversation-item .info .pl-box .hf-user p {
    font-size: 24px;
    color: rgb(51, 51, 51, 0.5);
  }

  .conversation-item .info .pl-box .hf-pl {
    font-size: 24px;
    color: rgb(51, 51, 51, 0.5);
    margin-bottom: 20px;
  }

  .conversation-item .info .pl-content {}

  .conversation-item .info .pl-text {
    color: #fff;
    font-size: 26px;
  }

  .conversation-item .info .pl-mention {
    color: #333;
    font-weight: 600;
    font-size: 26px;
    text-decoration: underline;
  }

  .conversation-item .info .time {
    font-size: 24px;
    color: #999;
  }

  .conversation-item.my {
    flex-direction: row-reverse;
    text-align: right;
  }

  .conversation-item.my .user-avatar {
    margin-right: 0;
    margin-left: 20px;
    flex-shrink: 0;
  }

  .conversation-item.my .info {
    align-items: flex-end;
  }

  .conversation-item.my .title {
    justify-content: flex-end;
  }

  .conversation-item.my .title .time {
    color: #999;
  }

  .conversation-item.my .info .pl-box {
    background-color: #12CDB0;
  }

  .conversation-item.my .info .pl-box .hf-user {
    justify-content: flex-end;
  }

  .conversation-item.my .info .pl-box .hf-user p {
    color: rgb(255, 255, 255, 0.5);
  }

  .conversation-item.my .info .pl-box .hf-pl {
    color: rgb(255, 255, 255, 0.5);
  }

  .conversation-item.my .info .pl-mention {
    color: #fff;
  }

  .conversation-item.my .pl-text {

    color: #fff;
  }

  .conversation-item .status {
    font-size: 24px;
    color: rgb(228, 98, 64);
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .cz-box {
    position: absolute;
    bottom: 0;
    right: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px 2px rgba(114, 114, 114, 0.25);
    border-radius: 20px;
  }

  .cz-box .cz-box-item {
    font-size: 26px;
    color: #666;
    padding: 20px 40px;
  }
</style>